import Head from 'next/head';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import ConnectLayout from 'components/Layout/Connect';
import SigninWithToken from 'containers/Login/SigninWithToken';
import AutoLoginLayout from 'components/Layout/Connect/AutoLogin';
import LoginWithToken from 'containers/Login/LoginWithToken';

const ResetPassword = dynamic(() => import('containers/Login/ResetPassword'), {
  ssr: false,
});

const Signup = dynamic(() => import('containers/Signup'), {
  ssr: false,
});

const Login = dynamic(() => import('containers/Login'), {
  ssr: false,
});

const ForgotPassword = dynamic(() => import('containers/ForgotPassword'), {
  ssr: false,
});

const whichMethodUse = (method, isResetting, mobile, setOpenModal) => {
  switch (method) {
    case 'signup':
      return <Signup setOpenModal={setOpenModal} />;
    case 'forgot-password':
      return <ForgotPassword />;
    case 'confirm-account':
      return <SigninWithToken />;
    case 'signin-with-token':
      return <SigninWithToken />;
    default:
      if (isResetting) return <ResetPassword />;
      return <Login mobile={mobile} />;
  }
};

const ConnectPage = ({ mobile, setOpenModal }) => {
  const { query } = useRouter();
  const resettingPwd = query?.method?.[0] === 'reset-password' && query.email && query.resetCode;

  return (
    <>
      <Head>
        <title>Happyneuron Academy</title>
      </Head>

      {query?.token?.length ? (
        <AutoLoginLayout mobile={mobile}>
          <LoginWithToken token={query.token} />
        </AutoLoginLayout>
      ) : (
        <ConnectLayout mobile={mobile}>
          {whichMethodUse(query?.method?.[0], resettingPwd, mobile, setOpenModal)}
        </ConnectLayout>
      )}
    </>
  );
};

export default ConnectPage;
